import React from 'react'

import {alpha, Box, Grid, Typography} from "@mui/material"
import {IconSeeker} from "@ui-seeker/core";
import { dsColorNew } from "@palette"


// A branch row is one grey cell across the dates (drawn by the first date column); a provider row
// has that provider's weeks for the date.
export default function pricesColumn(date, weeks, palette, idx, total) {

    return {
        name: date,
        setBodyCellProps: (_, row) => row?.isBranch
            ? { colSpan: total, sx: { p: 0, backgroundColor: dsColorNew.pillTrackBg, borderBottom: `1px solid ${dsColorNew.grayBorder}` } }
            : { sx: { p: 0, verticalAlign: 'top', userSelect: 'none', cursor: 'default', borderBottom: 0 } },
        render: (cells, row) => row?.isBranch
            ? (idx === 0 ? <Box/> : null)
            : <PriceCell cells={cells} weeks={weeks} />

    }
}

function PriceCell({cells, weeks}) {
    return <Box sx={{ p: 1, borderBottom: `1px solid ${dsColorNew.grayBorder}`}}>
        <Grid container spacing={1} sx={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'start' }}>
            {!cells ? weeks.map((week, idx) => {
                    return <Grid key={`${week}-${idx}`} item xs={12 / weeks.length} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'start', flexDirection: 'column' }}>
                        <Typography sx={{ borderRadius: '8px', textAlign: 'center', width: '100%', fontSize: 13, color: dsColorNew.textSubtle, border: `1px dashed ${dsColorNew.grayBorder}` }}>N/A</Typography>
                    </Grid>
                }) : cells.map(({price, isCheapest, isMoreExpensive, evolutionComparisonType, evolutionDiffPrice}, idx) => {
                    return <Grid key={`${price}-${idx}`} item xs={12 / weeks.length} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'start', width: '100%' }}>
                        <Box sx={{
                            border: price === 'N/A' ? `1px dashed ${dsColorNew.grayBorder}` : '1px solid',
                            borderColor: isCheapest ? alpha(dsColorNew.dangerRed, 0.45) : isMoreExpensive ? alpha(dsColorNew.appBlue, 0.45) : dsColorNew.grayBorder,
                            backgroundColor: isCheapest ? alpha(dsColorNew.dangerRed, 0.08) : isMoreExpensive ? alpha(dsColorNew.appBlue, 0.08) : price === 'N/A' ? '' : dsColorNew.white,
                            display: 'flex', alignItems: 'center', justifyContent: 'center', borderRadius: '8px', width: '100%'
                        }}>
                            <Grid container spacing={1}>
                                <Grid item xs={12}>
                                    <Typography sx={{textAlign: 'center', fontWeight: 'bold'}}>
                                        {price}
                                    </Typography>
                                </Grid>
                                 <Grid item xs={12} sx={{  height: 30 }}>
                                     {!!evolutionComparisonType && evolutionDiffPrice !== null && <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 1, px: 2 }} >
                                        <IconSeeker
                                            icon={evolutionComparisonType === "increase" ? "arrow-up" : evolutionComparisonType === "decrease" ? "arrow-down" : "equals"}
                                            sx={{ color: evolutionComparisonType === "increase" ? dsColorNew.successText : evolutionComparisonType === "decrease" ? dsColorNew.dangerRed : "" }}
                                        />
                                        <Typography sx={{textAlign: 'center', fontSize: 11  }}>
                                            {evolutionDiffPrice}%
                                        </Typography>
                                    </Box>}
                                </Grid>
                            </Grid>
                        </Box>
                    </Grid>
                })}
        </Grid>
    </Box>
}